import type { DayHours } from '../types/shop';

export type OpenStatus = {
  isOpen: boolean;
  label: string;
};

export function formatTime(time: string): string {
  const [h, m] = time.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return m === 0 ? `${hour} ${period}` : `${hour}:${String(m).padStart(2, '0')} ${period}`;
}

export function formatHoursRange(day: DayHours): string {
  if (!day.open || !day.close) return 'Closed';
  return `${formatTime(day.open)} – ${formatTime(day.close)}`;
}

export function getOpenStatus(hours: DayHours[], now: Date): OpenStatus {
  const todayIndex = now.getDay();
  const minutes = now.getHours() * 60 + now.getMinutes();
  const today = hours.find((h) => h.dayIndex === todayIndex);

  if (today?.open && today.close) {
    const open = toMinutes(today.open);
    const close = toMinutes(today.close);
    if (minutes >= open && minutes < close) {
      return { isOpen: true, label: `Open now · until ${formatTime(today.close)}` };
    }
    if (minutes < open) {
      return { isOpen: false, label: `Closed · opens today at ${formatTime(today.open)}` };
    }
  }

  for (let offset = 1; offset <= 7; offset++) {
    const next = hours.find((h) => h.dayIndex === (todayIndex + offset) % 7);
    if (next?.open) {
      const when = offset === 1 ? 'tomorrow' : next.day;
      return { isOpen: false, label: `Closed · opens ${when} at ${formatTime(next.open)}` };
    }
  }

  return { isOpen: false, label: 'Closed' };
}

function toMinutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}
